import { WithRequiredProperty } from '@fullstory/typeutils';
import { classNames } from '@fullstory/util/fmt';
import React from 'react';
import css from './InlineLink.module.scss';

export interface ExternalLinkProps
  extends WithRequiredProperty<React.ComponentPropsWithoutRef<'a'>, 'href'> {
  /**
   * When `true`, target="_blank" and rel="noopener noreferrer" attributes will
   * be automatically added to the anchor element
   */
  newTab?: boolean;
  /**
   * Use `inverse` on a dark background.
   */
  variant?: 'inverse';
  to?: never;
}

export const ExternalLink = React.forwardRef<HTMLAnchorElement, ExternalLinkProps>(
  ({ newTab = false, variant, ...props }, ref) => {
    const newTabProps: Pick<React.ComponentProps<'a'>, 'rel' | 'target'> | {} = newTab
      ? { target: '_blank', rel: 'noopener noreferrer' }
      : {};

    return (
      <a
        data-component="ExternalLink"
        className={classNames(css.link, { [css.inverse]: variant === 'inverse' })}
        ref={ref}
        {...newTabProps}
        {...props}
      >
        {props.children}
      </a>
    );
  },
);

ExternalLink.displayName = 'ExternalLink';
